module.exports = __webpack_public_path__ + "img/banner_store.c97f4b49.png";